/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Open Source Version is distributed with Sencha Ext JS pursuant to a FLOSS Exception agreed upon
 * between Sonatype, Inc. and Sencha Inc. Sencha Ext JS is licensed under GPL v3 and cannot be redistributed as part of a
 * closed source work.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

/**
 * Whether Sonatype-internal developer tooling should be enabled.
 * Currently gates the Test Hub, but is intended to cover other internal-only
 * developer tooling going forward (as opposed to `?debug`, which stays scoped
 * to loading changed files from the filesystem).
 * True when the SONATYPE_INTERNAL build flag was set at build time, or when a developer
 * has opted in at runtime via `localStorage.setItem('SONATYPE_INTERNAL', 'true')`.
 */
export function isSonatypeDevMode() {
  if (typeof __SONATYPE_INTERNAL__ !== 'undefined' && __SONATYPE_INTERNAL__) {
    return true;
  }
  try {
    return typeof localStorage !== 'undefined' && localStorage.getItem('SONATYPE_INTERNAL') === 'true';
  } catch {
    return false;
  }
}
